import { useCallback } from 'react';
import { useIntl } from 'react-intl';

const useTranslation = () => {
  let intl = null;

  try {
    intl = useIntl();
  } catch (error) {
    // IntlProvider is not available in this tree — fall back below.
    intl = null;
  }

  // Memoized so components/hooks that depend on `translate` (useMemo/useCallback/
  // React.memo deps) don't invalidate on every render — only when the locale changes.
  const translate = useCallback((id, values = {}) => {
    if (!intl) {
      if (typeof id !== 'string') return '';
      // Return the last part after the last dot, or the whole string
      const parts = id.split('.');
      return parts[parts.length - 1] || id;
    }

    // If it's not a string or doesn't look like a message id (no dot segments),
    // treat it as a literal label and return as-is to avoid missing translation warnings.
    if (typeof id !== 'string' || id.indexOf('.') === -1) {
      return typeof id === 'string' ? id : '';
    }
    // Use defaultMessage=id to gracefully fallback without noisy errors
    return intl.formatMessage({ id, defaultMessage: id }, values);
  }, [intl]);

  return translate;
};
export default useTranslation;
